export default __webpack_public_path__ + "static/1-mobile-aac0c224a82683752d1c2af5a0db88ea.webp";